export default __webpack_public_path__ + "static/media/bg.bce1ac83.png";